<template>
  <a-form :form="form">
    <a-form-item label="岗位名称" :label-col="labelCol" :wrapper-col="{ span: 10 }">
      <a-input
        v-decorator="[
          'jobName',
          {
            rules: [{ required: true, message: '请填写岗位名称' }],
            initialValue: initialValue.jobName,
          },
        ]"
      />
    </a-form-item>

    <a-form-item label="社招/校招" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-radio-group
        :options="recruitTypeOptions"
        v-decorator="[
          'recruitType',
          {
            rules: [{ required: true, message: '请选择' }],
            initialValue: `${initialValue.recruitType}`,
          },
        ]"
      >
      </a-radio-group>
    </a-form-item>

    <a-form-item label="技术/非技术" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-radio-group
        :options="jobTypeOptions"
        v-decorator="[
          'jobType',
          {
            rules: [{ required: true, message: '请填写优先级' }],
            initialValue: `${initialValue.jobType}`,
          },
        ]"
      >
      </a-radio-group>
    </a-form-item>

    <a-form-item label="工作国家" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-select
        :style="{ width: '200px' }"
        :options="countryOptions"
        @select="handleSelectCountry"
        v-decorator="[
          'country',
          {
            rules: [{ required: true, message: '请选择' }],
            initialValue: initialValue.country,
          },
        ]"
      >
      </a-select>
    </a-form-item>

    <a-form-item label="工作城市" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-select
        :style="{ width: '200px' }"
        :options="cityOptions"
        v-decorator="[
          'city',
          {
            initialValue: initialValue.city,
          },
        ]"
      >
      </a-select>
    </a-form-item>

    <a-form-item label="职位是否展示" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-switch
        v-decorator="[
          'isShow',
          {
            rules: [{ required: true, message: '请填写优先级' }],
            valuePropName: 'checked',
            initialValue: initialValue.isShow,
          },
        ]"
        checkedChildren="是"
        unCheckedChildren="否"
      />
    </a-form-item>

    <a-form-item label="职位优先级" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-input-number
        :min="0"
        v-decorator="[
          'priority',
          {
            rules: [{ required: true, message: '请填写优先级' }],
            initialValue: initialValue.priority,
          },
        ]"
      />
    </a-form-item>

    <a-form-item label="简历接收邮箱" :label-col="labelCol" :wrapper-col="{ span: 8 }">
      <a-input
        v-decorator="[
          'email',
          {
            rules: [
              {
                required: true,
                message: '请填写正确的邮箱',
                pattern: /[A-Za-z0-9]+@[A-Za-z0-9\.]+/,
              },
            ],
            initialValue: initialValue.email,
          },
        ]"
      />
    </a-form-item>

    <a-form-item label="添加日期" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-date-picker
        :allowClear="false"
        v-decorator="[
          'createdAt',
          {
            initialValue: initialValue.createdAt,
          },
        ]"
      />
    </a-form-item>

    <a-form-item label="职位描述" :label-col="labelCol" :wrapper-col="wrapperCol">
      <Editor :initial-value="initialValue.description" ref="tinymceEditor"></Editor>
    </a-form-item>

    <a-form-item label=" " :label-col="labelCol" :wrapper-col="wrapperCol" :colon="false">
      <a-button @click="handleSave" type="primary" class="btn-save">保存</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { getCountries, getCities, createJob, updateJob, getJobDetail } from '@/apis/index';
import Editor from '@/components/Editor';
import moment from 'moment';
import { recruitType, jobType } from '@/config/contant';
import { objToOptions } from '@/utils/common';
import { mapState } from 'vuex';

let hasSaved = false;

export default {
  components: {
    Editor,
  },
  props: {
    id: [Number, String],
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: this.$form.createForm(this),
      initialValue: {
        title: '',
        description: '',
        isShow: true,
        createdAt: moment(),
      },
      recruitTypeOptions: objToOptions(recruitType),
      jobTypeOptions: objToOptions(jobType),
      countryOptions: [],
      cityOptions: [],
    };
  },
  // computed: {
  //   ...mapState({
  //     countryOptions: state => state.countries.map(item => ({
  //       label: item.name,
  //       value: item.id,
  //     })),
  //   }),
  // },
  beforeRouteLeave(to, from, next) {
    if (!hasSaved) {
      this.$confirm({
        title: '你将失去编辑中的内容，是否确认离开？',
        okText: '确认离开',
        cancelText: '取消',
        onOk: () => next(),
        onCancel: () => next(false),
      });
    } else {
      next();
    }
  },
  async created() {
    const result = await getCountries();
    this.countryOptions = result.data.map(c => ({ key: c.id, label: c.name }));

    if (this.id) {
      const { code, data, msg } = await getJobDetail(this.id);

      if (code === 0) {
        this.initialValue = {
          ...data,
          isShow: Boolean(data.isShow),
          recruitType: +data.recruitType,
          createdAt: moment(data.createdAt),
        };
        this.handleSelectCountry(data.country);
      } else {
        this.$message.error(msg);
      }
    }
  },
  beforeDestroy() {
    hasSaved = false;
  },
  methods: {
    handleSave() {
      this.form.validateFields((err, fieldValues) => {
        if (!err) {
          const params = {
            ...fieldValues,
            description: this.$refs.tinymceEditor.getContent(),
            createdAt: fieldValues.createdAt.format('YYYY-MM-DD HH:mm:ss'),
            isShow: Number(fieldValues.isShow),
          };

          const apiMethod = this.id ? updateJob : createJob;

          apiMethod(params, this.id)
            .then(({ code, msg }) => {
              if (code === 0) {
                const back = this.$router.replace.bind(this.$router, { name: 'jobs' });

                hasSaved = true;
                this.$message.success('保存成功', 1, back);
              } else {
                this.$message.error(msg);
              }
            })
            .catch(error => {
              if (error.response.data) {
                if (error.response.data.code === 10002) {
                  this.$message.error('参数错误');
                }
              }
            });
        }
      });
    },

    async handleSelectCountry(id) {
      const result = await getCities({ country: id });
      this.cityOptions = result.data.map(c => ({ key: c.id, label: c.city }));
    },

    normFile(e) {
      const { file } = e;
      if (file && file.status === 'done' && file.response && file.response.url) {
        file.url = file.response.url;
      }
      return [file];
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-save {
  width: 100px;
}
</style>
